import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { CourseStateLight } from 'components/atoms/CourseStateLight';
import Picture from 'components/atoms/Picture/Picture';
import Link from 'components/atoms/Link/Link';
import { CourseBoxProps } from './CourseBox.types';
import {
  ContextBoxStyled,
  GridItemWrapper,
  ImageStyled,
  PriceBoxStyled,
  SlotInfoStyled,
  SlotPriceStyled,
  SlotsStyled,
  StatusStyled,
  TitleStyled,
  StatusLabelStyled,
  InfoRowStyled,
  SlotTextStyled,
  IconStyled,
  IconWrapperStyled,
} from './CourseBox.styles';

export const CourseBox: React.FC<CourseBoxProps> = ({ className, data }) => {
  const { t, lang } = useTranslation('common');
  const router = useRouter();

  const link = {
    link_type: 'Document',
    uid: data._meta.uid,
    lang: data._meta.lang,
  };

  let mappedImage;

  // extract the thumbnail image data
  if (data.image && data.image.thumbnail) {
    const { thumbnail } = data.image;
    mappedImage = { ...thumbnail };
  }

  return (
    <GridItemWrapper data-anlass={data._anlassNr}>
      <Link
        skin="newsSliderItem"
        url={link}
        className={className}
        onPress={() => {
          router.push(`/${lang}${router.asPath.split('?')[0]}${link.uid}`, undefined, {
            shallow: true,
          });
        }}
      >
        <StatusStyled color={data.status_color}>
          <CourseStateLight color={data.status_color} />
          <StatusLabelStyled>{t(data.status_label)}</StatusLabelStyled>
        </StatusStyled>
        <ImageStyled>
          {mappedImage && <Picture noMinHeight image={mappedImage} objectFit />}
        </ImageStyled>
        <ContextBoxStyled>
          <TitleStyled>{data.title}</TitleStyled>
          <SlotsStyled>
            <InfoRowStyled>
              <IconWrapperStyled>
                <IconStyled name="CALENDAR" />
              </IconWrapperStyled>
              <SlotTextStyled>{data.date}</SlotTextStyled>
            </InfoRowStyled>
            <InfoRowStyled>
              <IconWrapperStyled>
                <IconStyled name="CLOCK" />
              </IconWrapperStyled>
              <SlotTextStyled>{data.time}</SlotTextStyled>
            </InfoRowStyled>
            <InfoRowStyled>
              <IconWrapperStyled>
                <IconStyled name="MAPCURSOR" />
              </IconWrapperStyled>
              <SlotTextStyled>{data.place}</SlotTextStyled>
            </InfoRowStyled>
            <InfoRowStyled>
              <IconWrapperStyled>
                <IconStyled name="TEACHER" />
              </IconWrapperStyled>
              <SlotTextStyled>{data.person}</SlotTextStyled>
            </InfoRowStyled>
          </SlotsStyled>
          <PriceBoxStyled>
            <SlotPriceStyled>{data.price_format}</SlotPriceStyled>
            <SlotInfoStyled>{data.info}</SlotInfoStyled>
          </PriceBoxStyled>
        </ContextBoxStyled>
      </Link>
    </GridItemWrapper>
  );
};
